export default __webpack_public_path__ + "static/media/codeChallenger.e142759d.png";